(function ($) {

    // ajax small groups
    var loading = false;

    function loadPosts(post_type_query, action) {
        const containerPosts = $('#post-container');
        const spinner = $('#loading');

        if (loading) return;
        loading = true;

        spinner.addClass('is-visible');
        containerPosts.empty();

        $.ajax({
            url: MyAjax.ajaxurl,
            type: 'POST',
            data: {
                action: action,
                post_type_query: post_type_query
            },
            success: function (response) {
                loading = false;
                spinner.removeClass('is-visible');
                if (response === 'no_more_posts' || !response) {
                    containerPosts.html('<p>Постів не знайдено.</p>');
                } else {
                    containerPosts.html(response);
                }
            },
            error: function () {
                loading = false;
                spinner.removeClass('is-visible');
                containerPosts.html('<p>Помилка завантаження постів.</p>');
            }
        });
    }


    $('.section-small-groups-list .tax-name').click(function (e) {
        e.preventDefault();
        if(!$(this).hasClass('active')) {
            $('.tax-name').removeClass('active');
            $(this).addClass('active');
            var post_type_query = $(this).data('slug');
            loadPosts(post_type_query, 'small_groups_ajax');
        }
    });

    // center tab
    function centerActiveCategory() {
        if (window.innerWidth < 1023) {
            const $activeCategory = $('.section-small-groups-list .tax-name.position-center');

            if ($activeCategory.length) {
                const $scrollContainer = $('.section-small-groups-list .wrap-scroll');
                const activeOffsetLeft = $activeCategory[0].offsetLeft;
                const activeWidth = $activeCategory.outerWidth();
                const containerWidth = $scrollContainer.width();
                const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);
                $scrollContainer.animate({scrollLeft: scrollPosition}, 300, 'swing');
            }
        }
    }

    centerActiveCategory();

    $('.section-small-groups-list .tax-name span').on('click', function (e) {
        e.preventDefault();
        const $parentItem = $(this).parent();
        $parentItem.addClass('position-center').siblings().removeClass('position-center');
        centerActiveCategory();
    });


})(jQuery);